// Copyright ©️ 2026 eVolve MEP, LLC

import { Flex, Loader } from '@mantine/core';

export const LoadingRow = () => (
  <Flex gap="xs" mx="md" align="center" h="100%">
    <Loader size="xs" />
    Loading...
  </Flex>
);
